import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  portfolioSelectedFiltersData: {
    TrendAnalysisBrekup: 'Revenue',
    CurrentCycleName: 'Cycle-1',
    LevelName: 'Brand',
    buName: 'FLC_SNACK',
    brand: null,
    segment: null,
    subBrand: null,
    skuName: null,
    Region: null,
    Channel: null
  }
};

const portfolioHealthSlice = createSlice({
  name: 'portfolioHealth',
  initialState,
  reducers: {
    setPortfolioSelectedFiltersData: (state, action) => {
      state.portfolioSelectedFiltersData = action.payload;
    }
  }
});

export const { setPortfolioSelectedFiltersData } = portfolioHealthSlice.actions;

export default portfolioHealthSlice.reducer;
